module.exports = __webpack_public_path__ + "img/pedidos.9f50d438.svg";